export const LEGAL_TERMS_OF_USE_CANCELLATION_POLICIES: string = `

### <!--= ++sectionIndex -->. Cancellation Policies
<!-- subSectionIndex = 0; -->

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Cancellation and Refund (SAAS)

You have a statutory right to cancel your subscription at any time, as set out in the relevant cancellation instructions. Please refer to the <button class="btn btn-link p-0" routerLink="cancellation-policy">Cancellation Policy</button> for further details on how to cancel.

Every user is entitled to a 14-day money back guarantee following the initial purchase of the software. Refunds are not issued after automatic renewal of the subscription. For further details, please see our <button class="btn btn-link p-0" routerLink="cancellation-policy">Cancellation Policy</button>.

Please be aware that the limitations specified below and in the **Refund Policy** may apply and could potentially affect your right to a refund.
`;
